import { render, staticRenderFns } from "./MenuUndoButton.vue?vue&type=template&id=39730ac3&"
import script from "./MenuUndoButton.vue?vue&type=script&lang=ts&"
export * from "./MenuUndoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports